/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraSoftwareSummaryEmbedAppQuery$parameters.ts';
import type { JiraSoftwareSummaryEmbedAppQuery } from './__generated__/JiraSoftwareSummaryEmbedAppQuery.graphql.ts';

type SummarySoftwareEmbedEntrypointComponent = EntryPointComponent<
	{
		summaryQuery: JiraSoftwareSummaryEmbedAppQuery;
	},
	{},
	{},
	{}
>;

export const summarySoftwareEmbedEntrypoint: EntryPoint<
	SummarySoftwareEmbedEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SummarySoftwareEmbedEntrypointComponent>(
		/* webpackChunkName: "async-summary-software-embed-entrypoint" */ './JiraSoftwareSummaryEmbedApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				summaryQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
			},
		};
	},
});
